import { render, staticRenderFns } from "./AppNavigationLink.vue?vue&type=template&id=4029155c&"
import script from "./AppNavigationLink.vue?vue&type=script&lang=js&"
export * from "./AppNavigationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports